import { observer } from 'mobx-react-lite';
import { Outlet, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { SidebarProvider, useSidebar } from './SidebarContext';

const AppLayoutContent = observer(() => {
  const { isCollapsed } = useSidebar();
  const inspector =
    useLocation().pathname.replace(/\/+$/, '') === '/room-inspector';

  // 显示正常内容（ProtectedRoute 已经处理了初始化和未登录的情况）
  return (
    <div
      className={cn(
        'bg-gray-50/50 text-foreground font-body',
        inspector ? 'h-dvh overflow-hidden' : 'min-h-screen',
      )}
    >
      <Sidebar />
      <div
        className={cn(
          'transition-all duration-200',
          isCollapsed ? 'lg:pl-16' : 'lg:pl-48',
          inspector && 'flex h-full min-h-0 flex-col [&>header]:shrink-0',
        )}
      >
        <Header />
        <main
          className={
            inspector
              ? 'flex min-h-0 flex-1 flex-col overflow-hidden p-3'
              : 'min-h-[calc(100vh-3.5rem)] px-6 py-6'
          }
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
});

export function AppLayout() {
  return (
    <SidebarProvider>
      <AppLayoutContent />
    </SidebarProvider>
  );
}
